<template>
    <b-modal ref="modal" centered hide-header no-close-on-backdrop no-close-on-esc hide-footer>
        <div class="modal-header">
            <div class="modal-title">
                <h5>{{$t('SUBMITBUTTON')}}</h5>
            </div>
            <button type="button" aria-label="Close" @click="close()" class="close"><img src="../../../../../assets/img/icon-close.svg"></button>
        </div>
        <div class="d-block mt-2 modal-content-inside">
          <div role="group" class="b-form-group form-group" v-if="formData != null">
              <div class="form-row">
                <div class="col-sm-12">
                  <b-form-fieldset v-bind:label="$t('LABEL')">
                    <inputvalidation :formerror="formError" name="label">
                        <b-form-input type="text" v-model="formData.label" maxlength="22"></b-form-input>
                    </inputvalidation>
                  </b-form-fieldset>
                </div>
              </div>
              <div class="form-row">
                <div class="col-sm-12">
                <b-form-fieldset v-bind:label="$t('ORDERNUM')">
                    <inputvalidation :formerror="formError" name="orderNum">
                    <b-form-input type="text" v-model="formData.orderNum"></b-form-input>
                    </inputvalidation>
                </b-form-fieldset>
                </div>
             </div>
              <div class="form-row">
                <div class="col-sm-12">
                  <b-form-fieldset v-bind:label="$t('NEXTSTEP')">
                    <inputvalidation :formerror="formError" name="label">
                        <lbselect 
                          :empty="true" 
                          :list="steps.root" 
                          :total-count="steps.totalCount"
                          :pagination="pagination"
                          v-on:reload="getSteps()"
                          v-model="formData.nextStepId" 
                          value-field="stepId" 
                          display-field="name">
                        </lbselect>
                    </inputvalidation>
                  </b-form-fieldset>
                </div>
              </div>
                <div class="form-row">
                    <div class="col-sm-6">
                        <b-form-fieldset v-bind:label="$t('ISFINAL')">
                            <inputvalidation :formerror="formError" name="isFinal">
                                <b-form-checkbox v-model="formData.isFinal" :value="1" :unchecked-value="0">{{$t('ISFINAL')}}</b-form-checkbox>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                    <!--div class="col-sm-6">
                        <b-form-fieldset v-bind:label="$t('ISDEFECT')">
                            <inputvalidation :formerror="formError" name="isDefect">
                                <b-form-checkbox v-model="formData.isDefect" :value="1" :unchecked-value="0">{{$t('ISDEFECT')}}</b-form-checkbox>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div-->
                    <div class="col-sm-6">
                        <b-form-fieldset v-bind:label="$t('ISRETURNING')">
                            <inputvalidation :formerror="formError" name="isReturning">
                                <b-form-checkbox v-model="formData.isReturning" :value="1" :unchecked-value="0">{{$t('ISRETURNING')}}</b-form-checkbox>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                    <div class="col-sm-6" v-if="formData.isFinal == null || formData.isFinal == 0">
                        <b-form-fieldset v-bind:label="$t('SKIPCHECK')">
                            <inputvalidation :formerror="formError" name="skipCheck">
                                <b-form-checkbox v-model="formData.skipCheck" :value="1" :unchecked-value="0">{{$t('SKIPCHECK')}}</b-form-checkbox>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                </div>
                <div class="form-row" v-if="formData.isFinal == 1">
                    <div class="col-sm-12">
                        <b-form-fieldset v-bind:label="$t('STATUS')">
                            <inputvalidation :formerror="formError" name="status">
                                <b-form-select :options="status" v-model="formData.status"></b-form-select>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                </div>
          </div>

          <div class="text-center mt-lg">
              <b-btn class="mr-2 btn-bis btn-cancel" @click="close()">{{$t('CANCEL')}}</b-btn>
              <b-btn class="btn-bis btn-primary" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
          </div>
        </div>
    </b-modal>
</template>

<script>
import
{
    mapGetters,
}
    from 'vuex';    
import Api from '@/api/flow/StepButton.js';
import StepsApi from '@/api/flow/Step.js';


export default
{
    name: 'StepButtonsForm',
    props: ['value', 'stepId', 'flowId'],
    data()
    {
        const me = this;

        return {
            steps: {},
            formError: {},
            formData: null,
            status: [
                {
                    value: 'finished',
                    text: me.$i18n.t('FINISHED')
                },
                {
                    value: 'canceled',
                    text: me.$i18n.t('CANCELED')
                },
                {
                    value: 'partialyfinished',
                    text: me.$i18n.t('PARTIALYFINISHED')
                },
            ],
            pagination: {
                query: '',
                currentPage: 1,
                limit: 25,
                searchTimeout: false,
            },
        };
    },
    methods:
    {
        async submitData(item)
        {
            const me = this;
            try
            {
                if (typeof item.stepButtonId !== 'undefined')
                {
                    item.id = item.stepButtonId;
                    delete (item.stepButtonId);
                }

                item.stepId = me.stepId;
                const data = await Api.save(item);
                me.$notify.notice(data);

                if (data.error)
                {
                    me.formError = data;
                }
                else
                {
                    me.close();
                }
            }
            catch (e)
            {
              console.log(e);
                me.$notify.notice(e);
            }
        },
        async getSteps()
        {
            const me = this;
            try
            {
                const data = await StepsApi.selectRow(me.getParams);
                if (data.error && data.error === true)
                {
                    throw (data);
                }
                me.steps = data;
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
        },
        close()
        {
            const me = this;
            me.formData = null;
            me.formError = {};
            me.$emit('close');
        },
    },
    watch:
    {
        async formData(val)
        {
            const me = this;
            if (val != null)
            {
                await me.getSteps();
                me.$refs.modal.show();
            }
            else
            {
                me.$refs.modal.hide();
            }
        },
        value(val)
        {
            const me = this;
            if (val != null)
            {
                me.formData = { ...val };
            }
            else
            {
                me.formData = null;
            }
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
        ]),
        getParams()
      {
          const me = this;
          const data = { ...me.pagination };
          data.start = (data.currentPage - 1) * data.limit;
          data.flowId = me.flowId;
          return data;
      },
    },
};
</script>
